var _line, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInt3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 79,
    x2: 111,
    y2: 79,
    stroke: "#C8C4C0",
    strokeOpacity: 0.21,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3411 96.2497H52.6633C56.1654 96.2497 59.0044 93.4107 59.0044 89.9086V85.8279C59.0044 84.5286 58.6138 83.2536 57.7193 82.3114C55.717 80.2024 51.4507 76.649 45.4556 76.6799C39.4708 76.7107 35.2547 80.227 33.2755 82.317C32.3866 83.2557 32 84.5247 32 85.8174V89.9086C32 93.4107 34.839 96.2497 38.3411 96.2497Z",
    fill: "#CB7D57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5014,
    cy: 67.769,
    r: 10.769,
    fill: "#CB7D57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2547,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2547,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4227,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4227,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3411 96.2497H113.663C117.165 96.2497 120.004 93.4107 120.004 89.9086V85.8279C120.004 84.5286 119.614 83.2536 118.719 82.3114C116.717 80.2024 112.451 76.649 106.456 76.6799C100.471 76.7107 96.2547 80.227 94.2755 82.317C93.3866 83.2557 93 84.5247 93 85.8174V89.9086C93 93.4107 95.839 96.2497 99.3411 96.2497Z",
    fill: "#CB7D57"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.501,
    cy: 67.769,
    r: 10.769,
    fill: "#CB7D57"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.255,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.255,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.423,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.423,
    cy: 66.3484,
    r: 2.7879,
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt3);
export default __webpack_public_path__ + "static/media/int-3.026f6eab2a3bfa0254915eab587bcdd1.svg";
export { ForwardRef as ReactComponent };